import { render, staticRenderFns } from "./product-category.component.vue?vue&type=template&id=092788ba&scoped=true&lang=pug"
import script from "./product-category.component.vue?vue&type=script&lang=ts"
export * from "./product-category.component.vue?vue&type=script&lang=ts"
import style0 from "./product-category.component.vue?vue&type=style&index=0&id=092788ba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "092788ba",
  null
  
)

export default component.exports